// Copyright ©️ 2026 eVolve MEP, LLC

import { Box, Tooltip } from '@mantine/core';

import { isNavActionOption, type NavOption } from 'app/Layout/NavBar/globalNavigationMenu';
import { StyledNavLink } from 'app/Layout/NavBar/NavBarContent/StyledNavLink';
import { useAppShell } from 'app/Layout/NavBar/useAppShell';
import { useEvolveNavigate } from 'components/Mantine/Navigation/useEvolveNavigate';
import { useFabricationBendCreator } from 'modules/Shop/EvolveFabrication/BendCreator/useFabricationBendCreator';

type Props = {
  item: NavOption;
  withLabel: boolean;
  onClick?: () => void;
  active?: boolean;
};

export const NavItem = ({ item, withLabel, onClick, active }: Props) => {
  const navigate = useEvolveNavigate('', true);
  const { closeMobileNav } = useAppShell();
  const { openBendCreator, canOpenBendCreator } = useFabricationBendCreator();

  const handleClick = () => {
    onClick?.();
    closeMobileNav();
    if (isNavActionOption(item)) {
      openBendCreator();
    } else {
      void navigate(item.route);
    }
  };

  if (isNavActionOption(item) && !canOpenBendCreator) {
    return (
      <Tooltip label="Select a project to use the bend creator" position="right">
        <Box>
          <StyledNavLink label={item.label} onClick={handleClick} withLabel={withLabel} disabled />
        </Box>
      </Tooltip>
    );
  }

  return <StyledNavLink label={item.label} onClick={handleClick} active={active} withLabel={withLabel} />;
};
